import { render, staticRenderFns } from "./step_config.vue?vue&type=template&id=6cbb5d3a&scoped=true"
import script from "./step_config.vue?vue&type=script&lang=js"
export * from "./step_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb5d3a",
  null
  
)

export default component.exports